import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type IPrivateAsset, privateAssetsManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';

const PRIVATE_ASSET_MODULE = 'privateAsset';

const dataObjectModule = getDataObjectsModule<IPrivateAsset>(privateAssetsManager, 5);
const searchModule = getSearchModule();

const privateAssetModuleInstance = merge<unknown>(dataObjectModule, searchModule, { actions });
store.registerModule(PRIVATE_ASSET_MODULE, privateAssetModuleInstance);

export { PRIVATE_ASSET_MODULE };
